import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const lightTheme = {
  mode: 'light',
  background: 'linear-gradient(135deg, #ffffff 0%, #f5f0ff 50%, #e8f4ff 100%)',
  navBackground: 'rgba(255, 255, 255, 0.95)',
  navBackgroundScrolled: 'rgba(255, 255, 255, 0.98)',
  cardBackground: 'rgba(255, 255, 255, 0.9)',
  cardBorder: 'rgba(124, 77, 255, 0.2)',
  textPrimary: '#2d2d44',
  textSecondary: '#5a5a7a',
  accent: '#7c4dff',
  accentLight: '#b39ddb',
  accentGradient: 'linear-gradient(90deg, #7c4dff 0%, #536dfe 50%, #7c4dff 100%)',
  heroOverlay: 'linear-gradient(135deg, rgba(124, 77, 255, 0.1) 0%, rgba(83, 109, 254, 0.1) 100%)',
  sectionAlt: 'rgba(124, 77, 255, 0.05)',
  shadow: '0 10px 40px rgba(124, 77, 255, 0.15)',
  footerBg: 'linear-gradient(135deg, #f5f0ff 0%, #e8f4ff 100%)',
};

export const darkTheme = {
  mode: 'dark',
  background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
  navBackground: 'rgba(26, 26, 46, 0.8)',
  navBackgroundScrolled: 'rgba(26, 26, 46, 0.95)',
  cardBackground: 'rgba(255, 255, 255, 0.05)',
  cardBorder: 'rgba(179, 157, 219, 0.2)',
  textPrimary: '#ffffff',
  textSecondary: '#b39ddb',
  accent: '#7c4dff',
  accentLight: '#b39ddb',
  accentGradient: 'linear-gradient(90deg, #b39ddb 0%, #90caf9 50%, #ce93d8 100%)',
  heroOverlay: 'linear-gradient(135deg, rgba(106, 27, 154, 0.3) 0%, rgba(57, 73, 171, 0.3) 100%)',
  sectionAlt: 'rgba(0, 0, 0, 0.2)',
  shadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
  footerBg: 'rgba(0, 0, 0, 0.3)',
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved ? JSON.parse(saved) : false; // Default to light mode
  });

  const theme = isDarkMode ? darkTheme : lightTheme;

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <ThemeContext.Provider value={{ theme, isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
